<template>
  <div
    v-if="$store.state.authentification.connectUserID !== insight.owner_id"
    style="margin-right:10px;"
  >
    <b-tooltip v-bind:label="ownerMeeting">
      <span
        @mouseover="whoIsOwner(insight.owner_id)"
      >
        <img
          src="@/assets/img/icons/persons-icon.png"
          class="icon"
          alt="icon-share"
        />
      </span>
    </b-tooltip>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'WhoIsOwner',
  props: {
    insight: Object
  },
  data () {
    return {
      ownerMeeting: null
    }
  },
  methods: {
    whoIsOwner (id) {
      this.ownerMeeting = "Loading...";
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .get(process.env.VUE_APP_URL_SSO_API + "user/" + id)
        .then(response => {
          this.ownerMeeting =
            "Propriétaire : " +
            response.data.firstname +
            " " +
            response.data.lastname;
        })
        .catch(error => {
          this.errors.push(error), (this.ownerMeeting = "Erreur réseau");
          this.errors.push(
            "Erreur réseau,  Pas possible de récupérer le propriétaire de la réunion"
          );
        });
    },
  }
}
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  vertical-align: center;
}
</style>
